import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export interface IConfirmDeleteEntitiesOpts {
  standard?: boolean;
  description?: string;
  entity?: Entities;
}

export interface IConfirmDeleteEntitiesParams {
  /**
   * The number of entities to delete. Will be used to format the dialog
   * description text.
   *
   * @default 1
   */
  count?: number;
}

export interface IConfirmDeleteEntitiesFunction {
  (params?: IConfirmDeleteEntitiesParams): Promise<boolean>;
}

export const useConfirmDeleteEntities = (
  opts?: IConfirmDeleteEntitiesOpts
): IConfirmDeleteEntitiesFunction => {
  const { standard = false, description, entity } = opts ?? {};
  const dialogs = useDialogs();

  const { t } = useTranslation();

  const confirmDeleteEntities: IConfirmDeleteEntitiesFunction = (
    params = {}
  ) => {
    const { count = 1 } = params;

    if (standard) {
      let confirmDescription: string;

      if (description) {
        confirmDescription = description;
      } else if (entity) {
        const translationKey = `COMMON.DELETE_ENTITY.${entity}`.toUpperCase();

        const hasTranslation = t(translationKey) !== translationKey;

        confirmDescription = hasTranslation
          ? t(translationKey)
          : t('ALERTS.DELETE.CONFIRM');
      } else {
        confirmDescription = t('ALERTS.DELETE.CONFIRM');
      }

      return dialogs.confirm({
        title: t('ALERTS.DELETE.TITLE'),
        description: confirmDescription,
        confirmLabel: t('ALERTS.YES'),
        cancelLabel: t('ALERTS.NO'),
      });
    }

    return dialogs.confirm({
      title: t('ALERTS.DELETE.TITLE'),
      description: t('ALERTS.DELETE.REASSURE', { count }),
      confirmLabel: t('ALERTS.BTN_DELETE'),
      cancelLabel: t('ALERTS.BTN_ABORT'),
    });
  };

  return confirmDeleteEntities;
};
